export const REPORTE_DINAMICO = "REPORTE_DINAMICO";
export const REPORTE_DINAMICO_ERROR = "REPORTE_DINAMICO";
export const SHOW_TEXT = "SHOW_TEXT";
